import * as React from 'react';

import { Grid,  Button } from '@material-ui/core';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { Trans, TransProps, WithTranslation, withTranslation } from 'react-i18next';

import { window2config } from '../cfg/config';
import CONFIG from '../cfg/config';


import { connect } from 'react-redux';

import { AppState, Actions, store, IPageState } from '../appredux';

import { hotelService, webHotel, PortalInfo, Info, webRooms, roomsService, webRoom, passService, Bramka, Result, resetService } from '../api';
import { ClassNameMap } from '@material-ui/styles';




interface BramkiProps {
  page: IPageState,

  windowWidth: number,
  //bramki: Bramka[]
}

interface BramkiState {

  //bramki: Bramka[]
}

class Bramki extends React.Component<BramkiProps & WithTranslation & TransProps & WithStyles<typeof styles>, BramkiState> {

  constructor(props: BramkiProps & WithTranslation & WithStyles<typeof styles>) {
    super(props, {});
    window2config();
   
    this.state = {
     //bramki: this.props.page.bramki.length === 0 ? [] : this.props.page.bramki
    }
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps: Readonly<BramkiProps & WithTranslation & TransProps & { classes: ClassNameMap<'container' | 'item' | 'paper' | 'button'>; }>, prevState: Readonly<BramkiState>, snapshot?: any): void {
    
  }

  reset = async() => {  
    try {
      let res: any = await resetService.reset({})
      //console.log(res)
    } catch (error) {
      console.error()
    }

    try {
      let res: any = await resetService.resetKasjer({})
      //console.log(res)
    } catch (error) {
      console.error()
    }

    try {
      let res: any = await resetService.resetNadzorca({})
      //console.log(res)
    } catch (error) {
      console.error()
    }

    try {
      let res: any = await resetService.resetPsrv({})
      //console.log(res)
    } catch (error) {
      console.error()
    }


  }
  
  render() {
    const { classes, t } = this.props;
    // let colors = ["#458B00", "#008080", "#151c99",
    // "#5c8bdb", "#729156", "#800000",
    // "#458B00", "#008080", "#151c99"]

    //console.log(this.state.bramki)

    //let bramki = this.props.bramki.filter(x => x.aktywny === 1)

    return (
     <>

          <Grid container spacing={2} className={classes.container} justify='center' >

           
              <Grid item key={"service"} xs={12} sm={4} className={classes.item} >
                 <Button className={`${classes.button}`} variant="contained" color="primary"
                  //style={{ color: bramka.kolor, background: colors[index]}}
                  //style={{ background: bramka.kolor}}
                     onClick={() => this.reset()}
                     >
                     {t("Reset")}
                </Button> 
                
               </Grid>
          </Grid>
  
      </>
    );
  }
}

const styles = (theme: Theme) => ({

  container: {
    //margin: "0em",
    //paddingTop: "0.4em",
    padding: '2em 0em',
    minHeight: "100%"
  },
  item: {
    minHeight: "260px",
    maxHeight: "50vh",
    "@media (max-width: 900px)": {
      minHeight: "170px",
    }
  },
  paper : {
    //padding: "0px 6px", 
    //margin: "4px 4px", 
    //background: "linear-gradient(to bottom, #ffffff, #f7f7f7)",
    //szymek background: "#fcfcfc",
    position: "relative" as "relative",
    height: "50px"
},
button: { 
  fontSize: "20px", 
  height: "100%", 
  width: "100%",
  textTransform: "none" as "none",
  //fontWeight: "bold" as "bold",
  padding: "5px",
  //fontWeight: "bold" as "bold"
  "&:hover": {
    //color: "red",
    opacity: "70%"
  }
},
  
 
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(Bramki))); 

